import { HTTPMethod } from '../lib/http/http';

export enum AccountType {
  auto,
  UGit,
  TAPD,
  Cross,
}

export interface IProxyRequestBody {
  readonly method: HTTPMethod;
  readonly path: string;
  readonly query?: Object;
  readonly body?: Object;
}

export interface IProxyRequestBody {
  readonly method: HTTPMethod;
  readonly path: string;
  readonly query?: Object;
  readonly body?: Object;
}

export interface IFetchAllOptions<T> {
  /**
   * The number of results to ask for on each page when making
   * requests to paged API endpoints.
   */
  perPage?: number;

  /**
   * An optional predicate which determines whether or not to
   * continue loading results from the API. This can be used
   * to put a limit on the number of results to return from
   * a paged API resource.
   *
   * As an example, to stop loading results after 500 results:
   *
   * `(results) => results.length < 500`
   *
   * @param results  All results retrieved thus far
   */
  continue?: (results: ReadonlyArray<T>) => boolean;

  /**
   * Calculate the next page path given the response.
   *
   * Optional, see `getNextPagePathFromLink` for the default
   * implementation.
   */
  getNextPagePath?: (response: Response) => string | null;

  /**
   * Whether or not to silently suppress request errors and
   * return the results retrieved thus far. If this field is
   * `true` the fetchAll method will suppress errors (this is
   * also the default behavior if no value is provided for
   * this field). Setting this field to false will cause the
   * fetchAll method to throw if it encounters an API error
   * on any page.
   */
  suppressErrors?: boolean;

  timeout?: number; // ms
}
